module.exports = __webpack_public_path__ + "img/freturnicon1.ecbc8871.svg";